import { render } from "./Web3Status.vue?vue&type=template&id=1b2bc1e2"
import script from "./Web3Status.vue?vue&type=script&lang=js"
export * from "./Web3Status.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__